var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"btn refresh",on:{"click":function($event){return _vm.refresh()}}},[_vm._v("刷新试一试")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg error"},[_c('img',{attrs:{"src":require("../../../assets/images/common/error.png"),"alt":"出错了"}}),_c('div',{staticClass:"text"},[_vm._v("啊呀，网络出小差了")])])
}]

export { render, staticRenderFns }